import React, { useRef } from 'react'
import { Bar, getElementsAtEvent } from 'react-chartjs-2'
import { Grid, Paper } from '@mui/material'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

/** 
 * 
 * This component is expecting the following input. it will iterate through the BarChart section
{
    "Order": "50",
    "Visible": "1",
    "Label": "",
    "ComponentType": "KEY AREA CHART",
    "BarChart": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "HEART",
            "Score": "58",
            "ValueGrade": "2"
        }
    ]
}
*/

const KeyAreaGraph = (props) => {

    const chartRef = useRef(null);
    let graphcolors = ['#4eb748', '#E7C61E', '#E6323A', '#c0c0c0']
    const lables = props.component.BarChart.map(val => val.Visible == "1" ? val.Label : null).filter(n => n)
    const dataset = props.component.BarChart.map(val => val.Visible == "1" ? val.Score : null).filter(n => n)
    const colors = props.component.BarChart.map(val => val.Visible == "1" ? graphcolors[val.ValueGrade - 1] : null).filter(n => n)

    const data = {
        labels: lables,
        datasets: [{
            data: dataset,
            backgroundColor: colors,
            borderWidth: 0
        }]
    }
    const handleScrollToSection = (evt) => {
        let chartElement = getElementsAtEvent(chartRef.current, evt)
        let index = chartElement[0].index

        const element = document.getElementById("key_area_section_" + lables[index].toLowerCase());

        if (element) {

            element.scrollIntoView({

                block: "start",
                inline: "start",
                behavior: "smooth"
            });
        }
    };
    const config = {
        type: 'bar',
        data: data,
        options: { 
            indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    max: 100,
                    grid: {
                        display: true
                    },
                    ticks: {
                        stepSize: 20
                    }
                },
                x: {
                    grid: {
                        display: false
                    }
                    , ticks: {
                        display: false
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            },

        }
    }
    const motionVariants = {
        hidden: { opacity: 0, x: 0},
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1, 
                duration: 0.5, 
            }
        }
    }
    return (
        <Grid item lg={4} md={4} sm={6} xs={12} sx={{"@media print": {maxWidth:"300px"}}}
            justifyContent="center" alignItems="center" sx={{ padding: '10px' }}
        >
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>

                <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Bar
                        ref={chartRef}
                        data={data}
                        options={config.options}
                    //onClick={handleScrollToSection}
                    />
                </Paper> 
            </motion.div>
 
        </Grid>
    )
}

export default KeyAreaGraph